"use client";

import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import * as apiService from "../../service/apiService";
import useSWR from "swr";
import NoData from "../common/NoDataFound";
import NoDataFoundJson from "../../../public/json/NoDataFound.json";
import { Paragraph } from "../common/Paragraph";
import { generateProductListSchema } from "@/src/Seo/schemas/productSchema";
import Head from "next/head";
import Script from "next/script";
import { Button } from "../ui/button";

const fetcher = (url: string) => {
  const header = apiService.getAuthHeader();

  const auth = {
    method: "GET",
    ...header,
  };

  console.log(auth);

  if (header) {
    return fetch(url, {
      ...auth,
    }).then((res) => res?.json());
  } else {
    return fetch(url).then((res) => res?.json());
  }
};

const ProductList = ({
  categorySlug,
  searchTerm,
  url,
}: {
  categorySlug?: string;
  searchTerm?: string;
  url?: string;
}) => {
  // const [lastSnapDocList, setLastSnapDocList] = useState([]);
  // const [recentSnap, setRecentSnap] = useState(null);
  const [page, setPage] = useState(1); // Set a reasonable page size
  const [limit] = useState(10); // Set a reasonable page size
  const [productData, setProductData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);

  const [initialLoading, setInitialLoading] = useState(true);

  const [paginationLoading, setPaginationLoading] = useState(false);

  const key = apiService.fetchProductsString(
    page,
    limit,
    searchTerm ?? null,
    categorySlug,
  );

  const {
    data: apiData,
    isLoading,
    error,
  } = useSWR(key, fetcher, {
    // revalidateOnFocus: false,
    // revalidateOnReconnect: false,
    // dedupingInterval: Infinity,
    // revalidateIfStale: false,
  });

  useEffect(() => {
    console.log(apiData?.data?.data[0]);
    if (apiData) {
      setPage(apiData?.data?.page ?? 1);
      setTotalCount(apiData?.data?.total ?? 0);

      const data = apiData?.data?.data ?? [];
      setProductData((prev) => {
        // Combine existing data with the new data
        const combinedData = [...prev, ...data];

        // Create a Map to deduplicate based on `id`
        const uniqueData = Array.from(
          new Map(combinedData.map((item) => [item?._id, item])).values(),
        );

        return uniqueData;
      });

      setInitialLoading(false);
      setPaginationLoading(false);
    }
  }, [apiData]);

  const handleLoadMore = () => {
    if (paginationLoading) return;
    setPaginationLoading(true);
    setPage((prev) => prev + 1);
  };

  if (initialLoading)
    return (
      <div className="mt-14 flex flex-wrap gap-x-8 gap-y-16">
        {Array.from({ length: 5 }, (_, index) => (
          <ProductCard key={index} isLoading={true} data={null} priority />
        ))}
      </div>
    );

  const hasMore = productData.length < totalCount;

  const jsonLd = generateProductListSchema({
    productData: productData,
    url: url,
  });

  return (
    <>
      {
        // NO PRODUCT
        productData?.length <= 0 ? (
          <NoData jsonPath={NoDataFoundJson} />
        ) : (
          <>
            {/* <Head>
            </Head> */}
            <Script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
              strategy="afterInteractive"
            />

            <div className="">
              <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2 md:mt-14 md:grid-cols-3 xl:grid-cols-4">
                {productData?.map((e, index) => (
                  <ProductCard
                    key={index}
                    data={e}
                    isLoading={false}
                    priority={index <= 10}
                  />
                ))}
              </div>

              {hasMore && (
                <div className="mt-14 flex items-center justify-between">
                  <Paragraph className="text-gray-800">
                    {`Total Quality Product : ${totalCount}`}
                  </Paragraph>

                  <Button
                    onClick={handleLoadMore}
                    className="rounded-lg bg-main-900 px-4 py-2 text-white"
                    aria-label="Load more product button"
                  >
                    {isLoading ? "Loading..." : "Load more"}
                  </Button>
                </div>
              )}
            </div>
          </>
        )
      }
    </>
  );
};

export default ProductList;
